<script>
  import members from './stores/MemberStore.js';
  import MemberRoles from './options/MemberRoles.svelte';

  export let visible = true;
  export let app;
  let user;
  let error;
  let role;
  let userInput;

  const postMember = async () => {
    let member = {appId: app._id, user, role};
    const res = await members.post(member);
    if(!res.ok) error = res.body.message;
    if(res.ok) {
      user = '';
      error = '';
      role = 'User';
      userInput.focus();
    }
  }
</script>

{#if visible}
  <form on:submit|preventDefault={postMember}>
    <div class="field is-grouped is-grouped-multiline">
      <div class="control is-expanded">
        <input class="input is-small mr-0" size=16 type="email" placeholder="E-mail" bind:value={user} bind:this={userInput} required>
      </div>
      <div class="control">
        <div class="select is-small">
          <select bind:value={role}>
            <MemberRoles/>
          </select>
        </div>
      </div>
      <div class="control">
        <button class="button is-small is-light" name="submit" type="submit">Add</button>
      </div>
    </div>  
  </form> 
  {#if error}
    <div class="columns">
      <div class="column">
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Error</label>
          <div class="control">
            <textarea class="textarea is-danger" placeholder="Error" value={error}></textarea>
          </div>
        </div>
      </div>
    </div>
  {/if}
{/if}

<style>
  button {
  width: 70px;
}
</style>

